import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { Echeckin_Obj, getEcheckinConfig } from 'services';

export type State = ApiState<Echeckin_Obj, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchEcheckinConfig = createAsyncThunk('get/echeckinConfigs', async () => await getEcheckinConfig());

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  data: {},
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const echeckInItemsConfigSlice = createSlice({
  name: 'echeckinConfigItems',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEcheckinConfig.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchEcheckinConfig.fulfilled, (state, action: PayloadAction<Echeckin_Obj>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchEcheckinConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { echeckinConfigItems: State }): State => state.echeckinConfigItems;

export const eCheckinConfigs_ = createSelector(stateSelector_, (state) => state.data);

export default echeckInItemsConfigSlice.reducer;
